const transfers = {
  transfer: "Paglilipat", // translated 
  transfers: "Mga Paglilipat", // translated 
  dateAndTime: "Petsa at Oras", // translated 
  transferFrom: "Ilipat Mula sa", // translated 
  duration: "Tagal", // translated 
  numOfPersons: "Bilang ng mga Tao", // translated 
  baggageAllowance: "Allowance sa Bagahe", // translated 
  small: "Maliit", // translated 
  big: "Malaki", // translated 
  provider: "Tagapagbigay ng serbisyo", // translated 
  vehicle: "Sasakyan", // translated 
  distance: "Distansya", // translated 
  price: "Presyo", // translated 
  inboundJourney: "Paglalakbay Papasok", // translated 
  outboundJourney: "Paglalakbay Palabas", // translated 
  arrivalTime: "Oras ng Pagdating", // translated 
  flightDetails: "Mga Detalye ng Paglipad", // translated 
  inboundPickupDate: "Petsa ng Pagsundo Papasok", // translated 
  outboundPickupDate: "Petsa ng Pagsundo Palabas", // translated 
  travelInfo: "Impormasyon sa Paglalakbay", // translated 
  travellersInformation: "Impormasyon ng mga Manlalakbay", // translated 
  flightsInfo: "Impormasyon sa Mga Paglipad", // translated 
  airportYouAreFlyingFrom: "Paliparan na iyong pinanggalingan", // translated 
  airportYouAreFlyingTo: "Paliparan na iyong pupuntahan", // translated 
  inboundFlightNumber: "Numero ng Papasok na Paglipad", // translated 
  outboundFlightNumber: "Numero ng Palabas na Paglipad", // translated 
  inboundAirlineName: "Pangalan ng Papasok na Airline", // translated 
  outboundAirlineName: "Pangalan ng Palabas na Airline", // translated 
  tripMode: "Paraan ng Paglalakbay", // translated 
  airportToPoint: "Paliparan Patungong Punto", // translated 
  pointToAirport: "Ituro Patungong Paliparan", // translated 
  roundTrip: "Paglalakbay Pabalik-balik", // translated 
  destinationPoint: "Punto ng Destinasyon", // translated 
  originPoint: "Pinagmulan na Punto", // translated 
  transferType: "Uri ng Paglilipat", // translated 
  min: "Minuto", // translated 
  max: "Pinakamataas", // translated 
  pieces: "Mga piraso", // translated 
  cancelationIs: "ang pagkansela ay", // translated 
};


export default transfers;
